import {mapGetters} from "vuex";
import fa from "element-ui/src/locale/lang/fa";

//防抖
export function debounce(func, wait) {
  let timeout = null
  return function () {
    let context = this
    let args = arguments
    if (timeout) clearTimeout(timeout)
    timeout = setTimeout(() => {
      func.apply(context, args)
    }, wait)
  }
}

//验证手机号
export function valiPhone(val) {
  let reg_tel = /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/
  return reg_tel.test(val)
}

export function dataURItoBlob(base64Data) {
  let byteString = base64Data + '';
  if (base64Data.split(",")[0].indexOf("base64") >= 0) {
    byteString = atob(base64Data.split(",")[1]); // base64 解码
  } else {
    byteString = unescape(base64Data.split(",")[1]);
  }
  // 获取文件类型
  let mimeString = base64Data.split(",")[0].match(/:(.*?);/)[1]; // mime类型
  let uintArr = new Uint8Array(byteString.length); // 创建视图
  for (let i = 0; i < byteString.length; i++) {
    uintArr[i] = byteString.charCodeAt(i);
  }
  // 生成blob图片
  const blob = new Blob([uintArr], {
    type: mimeString
  });
  // 使用 Blob 创建一个指向类型化数组的URL, URL.createObjectURL是new Blob文件的方法,可以生成一个普通的url,可以直接使用,比如用在img.src上
  // return URL.createObjectURL(blob);
  return blob;
}

//获取当前日期
export function formatDate(fmt, currDate) {
  /*
   * eg:format="YYYY-MM-dd hh:mm:ss";
   */
  if (typeof currDate === 'number') currDate = new Date(currDate)
  var o = {
    'M+': currDate.getMonth() + 1, // 月份
    'd+': currDate.getDate(), // 日
    'h+': currDate.getHours(), // 小时
    'm+': currDate.getMinutes(), // 分
    's+': currDate.getSeconds() // 秒
  }

  if (/(Y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (currDate.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k])
        .length)))
    }
  }
  return fmt
}

//文件地址转file
export function getFileFromUrl(url, fileName) {
  return new Promise((resolve, reject) => {
    var blob = null;
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url);
    xhr.setRequestHeader('Accept', 'image/jpg');
    xhr.responseType = "blob";
    // 加载时处理
    xhr.onload = () => {
      // 获取返回结果
      blob = xhr.response;
      let file = new File([blob], fileName, {type: 'image/jpg'});
      // 返回结果
      resolve(file);
    };
    xhr.onerror = (e) => {
      reject(e)
    };
    // 发送
    xhr.send();
  });
}

export function IsExstsFile(yourFileURL) {
  var flag;
  var xmlhttp;
  if (window.XMLHttpRequest) {
    xmlhttp = new XMLHttpRequest();//其他浏览器
  } else if (window.ActiveXObject) {
    try {
      xmlhttp = new ActiveXObject("Msxml2.XMLHTTP");//旧版IE
    } catch (e) {
    }
    try {
      xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");//新版IE
    } catch (e) {
    }
    if (!xmlhttp) {
      window.alert("不能创建XMLHttpRequest对象");
    }
  }
  xmlhttp.open("GET", yourFileURL, false);
  xmlhttp.send();
  if (xmlhttp.readyState == 4) {
    if (xmlhttp.status == 200)
      flag = true;
    else
      flag = false;
  }
  return flag;
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  if (!time) time = new Date()
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  Object.keys(formatObj).forEach(key => {
    if(key==='a'){

      formatObj[key] = ['日', '一', '二', '三', '四', '五', '六'][formatObj[key]]
    }else if (formatObj[key] === 0) {
      formatObj[key] = '00'
    } else if (formatObj[key] > 0 && formatObj[key] < 10) {
      formatObj[key] = '0' + formatObj[key]
    }
  })
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })

  return formatObj
}


export function getCirlPoint(x0, y0, r, angle) {
  let x1 = x0 + r * Math.cos(angle * Math.PI / 180)
  let y1 = y0 + r * Math.sin(angle * Math.PI / 180)
  return {
    x: x1,
    y: y1
  }
}

export function pxChange(px) {
  return px
  // return window.htmlPx / 192 * px
}

export function getWeekStart(dd) {
  if(!dd) dd=new Date()
  var week = dd.getDay(); //获取时间的星期数
  var minus = week ? week - 1 : 6;
  dd.setDate(dd.getDate() - minus); //获取minus天前的日期
  var y = dd.getFullYear();
  var m = dd.getMonth() + 1; //获取月份
  var d = dd.getDate();
  return new Date(y + "-" + m + "-" + d).getTime()
}
export function parseTime2(time, cFormat) {
  if (!time) time = new Date()
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value || 0
  })
  return time_str
}
export function getWeekDay(n){
  let start=getWeekStart()
  let weekLong=24*60*60*7*1000
  start=start+weekLong*n
  let startDay=parseTime2(start,'{m}.{d}')
  let endDay=parseTime2((start+weekLong-1000),'{m}.{d}')
  return `${startDay}-${endDay}`

}

//千分位数字
export function toThousandFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}



// WEBPACK FOOTER //
// ./src/utils/tools.js